'use strict';

var React = require('react');
var l10n = require('@iziwork/l10n');
var component = require('../../Icon/component.js');
require('../../Tooltip/component.js');
var index = require('../Select/index.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const defaultPrefix = React__default.default.createElement(component.Icon, { name: "location-outlined", size: "m" });
const AddressAutocomplete = React.forwardRef(({ countryCode, prefix = defaultPrefix, suffix = null, ...props }, ref) => {
    const formatLabel = React.useCallback((address) => l10n.addressToString({ countryCode, address }), [countryCode]);
    return React__default.default.createElement(index.Select.Control, { ...props, ref: ref, prefix: prefix, suffix: suffix, formatLabel: formatLabel });
});
AddressAutocomplete.displayName = 'Address.Autocomplete';

exports.AddressAutocomplete = AddressAutocomplete;
//# sourceMappingURL=Autocomplete.js.map
